import React from 'react'

import './Loading.css'
const Loading = () => {
  return (
    <div className='loading-fullscreen'>
      <div className='loader'>
        <span>Loading</span>
      </div>
    </div>
  )
}

export default Loading